module.exports = __webpack_public_path__ + "static/media/openCollapse.d8c47ede.svg";